import { createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Download Times")
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "form-check mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, " use default ", -1)
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "Time", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Disable Download Times")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Do you want to disable the download times for players?", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Reboot the players ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Do you want to reboot the player?", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_16 = { class: "player-details-page" }
const _hoisted_17 = {
  class: "nav nav-tabs",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_20 = {
  class: "btn-group btn-group-sm mt-3",
  role: "group"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-dark",
  "data-bs-toggle": "modal",
  "data-bs-target": "#downloadTimesDisableModal"
}, " Disable DT ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-dark",
  "data-bs-toggle": "modal",
  "data-bs-target": "#rebootPlayersModal"
}, " Reboot ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "logs mt-2" }
const _hoisted_27 = {
  key: 2,
  class: "container-fluid mt-2"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { class: "players-content" }
const _hoisted_32 = { class: "col-sm-6 col-md-4 col-lg-3" }
const _hoisted_33 = { class: "card mt-3 mb-3" }
const _hoisted_34 = { class: "card-body snapshot-trigger" }
const _hoisted_35 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-camera-fill" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" New Snapshot ")
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_modal_component = _resolveComponent("modal-component")!
  const _component_player_dashboard = _resolveComponent("player-dashboard")!
  const _component_player_logs = _resolveComponent("player-logs")!
  const _component_content_stat = _resolveComponent("content-stat")!
  const _component_player_content = _resolveComponent("player-content")!
  const _component_snapshots_grid = _resolveComponent("snapshots-grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal_component, { id: "downloadTimesEnableModal" }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.downloadTimesDefault) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.downloadTimesDefault]
              ]),
              _hoisted_5
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Datepicker, {
                disabled: _ctx.downloadTimesDefault,
                modelValue: _ctx.downloadTimes,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.downloadTimes) = $event)),
                minutesIncrement: "5",
                timePicker: "",
                disableTimeRangeValidation: "",
                range: "",
                placeholder: "Select Time"
              }, null, 8, ["disabled", "modelValue"])
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _hoisted_9,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.enableDownloadTimes && _ctx.enableDownloadTimes(...args))),
          class: "btn btn-outline-dark"
        }, " Enable ")
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, { id: "downloadTimesDisableModal" }, {
      header: _withCtx(() => [
        _hoisted_10
      ]),
      body: _withCtx(() => [
        _hoisted_11
      ]),
      footer: _withCtx(() => [
        _hoisted_12,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.disableDownloadTimes && _ctx.disableDownloadTimes(...args))),
          class: "btn btn-outline-dark"
        }, " Disable ")
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, { id: "rebootPlayersModal" }, {
      header: _withCtx(() => [
        _hoisted_13
      ]),
      body: _withCtx(() => [
        _hoisted_14
      ]),
      footer: _withCtx(() => [
        _hoisted_15,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rebootPlayers && _ctx.rebootPlayers(...args))),
          class: "btn btn-outline-dark"
        }, " Reboot ")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("nav", null, [
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, ({ name, link }) => {
            return (_openBlock(), _createElementBlock("button", _mergeProps({
              onClick: ($event: any) => (_ctx.changeTab(link)),
              key: link
            }, {
            id: `nav-${link}-tab`,
            dataBsTarget: `#nav-${link}`,
            ariaControls: `nav-${link}`,
          }, {
              class: ["nav-link", { active: link == _ctx.activeTab }],
              "data-bs-toggle": "tab",
              type: "button",
              role: "tab",
              "aria-selected": "true"
            }), _toDisplayString(name), 17, _hoisted_18))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, ({ link }) => {
          return (_openBlock(), _createElementBlock("div", _mergeProps({
            key: link,
            class: ["tab-pane fade", { show: link == _ctx.activeTab, active: link == _ctx.activeTab }]
          }, {
          id: `nav-${link}`,
          ariaLabelledby: `nav-${link}-tab`,
        }, { role: "tabpanel" }), [
            (link == _ctx.tabLinks.GENERAL)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-dark",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#downloadTimesEnableModal",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onDTModalOpen(_ctx.downloadTimes)))
                    }, " Enable DT "),
                    _hoisted_22
                  ]),
                  _createVNode(_component_player_dashboard, { player: _ctx.player }, null, 8, ["player"])
                ], 64))
              : (link == _ctx.tabLinks.LOGS)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("button", {
                      class: "btn btn-light",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getLogs()))
                    }, _hoisted_25),
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_player_logs, { logs: _ctx.logs }, null, 8, ["logs"])
                    ])
                  ], 64))
                : (link == _ctx.tabLinks.CONTENT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_content_stat, {
                            cStatistics: _ctx.virtualClassesStates,
                            "onUpdate:cStatistics": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.virtualClassesStates) = $event))
                          }, null, 8, ["cStatistics"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_player_content, {
                              cMonitor: _ctx.virtualClassesStateCodes,
                              "onUpdate:cMonitor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.virtualClassesStateCodes) = $event))
                            }, null, 8, ["cMonitor"])
                          ])
                        ])
                      ])
                    ]))
                  : (link == _ctx.tabLinks.SNAPSHOTS)
                    ? (_openBlock(), _createBlock(_component_snapshots_grid, {
                        key: 3,
                        images: _ctx.snapshots
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                (_ctx.snapshotWaiting)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "btn btn-light",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.takeSnapshot()))
                                    }, _hoisted_40))
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["images"]))
                    : _createCommentVNode("", true)
          ], 16))
        }), 128))
      ])
    ])
  ], 64))
}